function scorePassword(pass) {
  let score = 0;
  const letters = {};

  if (!pass) {
    return score;
  }

  // award every unique letter until 5 repetitions

  for (let i = 0; i < pass.length; i += 1) {
    letters[ pass[ i ] ] = (letters[ pass[ i ] ] || 0) + 1;
    score += 5.0 / letters[ pass[ i ] ];
  }

  // bonus points for mixing it up
  const variations = {
    digits: /\d/.test(pass),
    lower: /[a-z]/.test(pass),
    upper: /[A-Z]/.test(pass),
    nonWords: /\W/.test(pass),
  };

  const variationCount = Object.keys(variations)
    .map(vari => variations[ vari ])
    .filter(vari => vari)
    .length;

  score += (variationCount - 1) * 10;

  return parseInt(score, 10);
}

export default scorePassword;



// WEBPACK FOOTER //
// ./lib/password-strength.js